<template>
  <div>
    <h2 class="is-uppercase">Equipo / Somos lo que creamos</h2>
    <div class="columns is-multiline is-mobile">
      <div
        class="column is-half-mobile is-one-third-tablet is-one-quarter-desktop"
        v-for="user in activeUsers"
        :key="user.name"
      >
        <div class="card bm--card-equal-height">
          <div class="card-image">
            <figure class="image">
              <img
                :src="require(`@/assets/team/${user.photo}`)"
                :alt="user.name"
              />
            </figure>
          </div>
          <div class="card-content">
            <div class="content">
              <strong>{{ user.name }}</strong>
              <br />
              {{ user.position }}
              <br />
              <i>"{{ user.info }}"</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from "@/data/team.json";
export default {
  name: "Team",
  data() {
    return { list };
  },
  computed: {
    activeUsers: function() {
      return this.list.filter(function(u) {
        return u.photo;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  max-width: 320px;
  height: 100%;
  text-align: left;
  border: medium none;
  box-shadow: none;

  .card-content {
    padding: 0.25em 0 0.75em 0;
  }

  strong {
    font-weight: bolder;
    font-size: 16px;
  }

  .card-footer {
    margin-top: auto;
  }
}
</style>
